export default __webpack_public_path__ + "static/media/Doxxed Team 6.15300206.jpg";